export default __webpack_public_path__ + "static/social-media-b7edfe68fced2bb26dd2bc6a65f83b4e.gif";